import { DashboardModel, EntityWiseDataModel } from '../../models/model'

export interface DashboardState extends DashboardModel {}

export const initialUserDashboardState: DashboardState = {
  statistics: [],
  announcements: [],
  calendarEvents: [],
  totalHeadCount: null
}

export interface EntityWiseDataState extends EntityWiseDataModel {}

export const initialEntityWiseDataState: EntityWiseDataState = {
  statistics: []
}
